// OtherSetting に関する型と定数を集約

export type weather = number;
export type battle_field = number;

// 場の状態をタグで管理するための識別子
export type BattleStatusTag = 'reflector' | 'light-screen' | 'gravity';

export const WEATHER_EMPTY: weather = 10000;
export const WEATHER_HARE: weather = 20000;
// おおひでり（ひざしがとてもつよい）：晴れと同様の効果 + みずタイプ攻撃技の無効化など（実装側で個別に扱う）
export const WEATHER_OOHIDERI: weather = 21000;
// らんきりゅう：ひこうタイプ弱点(でんき/いわ/こおり)の技ダメージを半減など（実装側で個別に扱う）
export const WEATHER_RANKIRYUU: weather = 22000;
export const WEATHER_AME: weather = 30000;
// おおあめ（つよいあめ）：雨と同様の効果 + ほのおタイプ攻撃技の無効化など（実装側で個別に扱う）
export const WEATHER_OOAME: weather = 31000;
export const WEATHER_SUNA: weather = 40000;
export const WEATHER_YUKI: weather = 50000;

export const BATTLE_FIELD_EMPTY: battle_field = 110000;
export const BATTLE_FIELD_PSYCHO_SAIKO: battle_field = 120000;
export const BATTLE_FIELD_EREKI: battle_field = 130000;
export const BATTLE_FIELD_MISUTO: battle_field = 140000;
export const BATTLE_FIELD_GLASS: battle_field = 150000;

export interface otherSetting {
  weather: weather;
  battle_field: battle_field;
  battleStatuses?: BattleStatusTag[];
}

const normalizeBattleStatuses = (
  statuses?: BattleStatusTag[],
): BattleStatusTag[] | undefined => {
  if (!statuses || statuses.length === 0) {
    return undefined;
  }

  return Array.from(new Set(statuses));
};

// タグ集合から指定状態の有無を判定
export const hasBattleStatus = (
  settings: otherSetting,
  status: BattleStatusTag,
): boolean => {
  if (settings.battleStatuses?.includes(status)) {
    return true;
  }

  return false;
};

// タグ集合をオン／オフする
export const setBattleStatus = (
  settings: otherSetting,
  status: BattleStatusTag,
  enabled: boolean,
): otherSetting => {
  const nextStatuses = new Set(settings.battleStatuses ?? []);
  if (enabled) {
    nextStatuses.add(status);
  } else {
    nextStatuses.delete(status);
  }

  const normalized = normalizeBattleStatuses(Array.from(nextStatuses));

  const nextSetting: otherSetting = { ...settings };

  if (normalized) {
    nextSetting.battleStatuses = normalized;
  } else {
    delete nextSetting.battleStatuses;
  }

  return nextSetting;
};
